export const labelStyle = {
  fontSize: '14px',
  fontWeight: 'normal',
  color: '#161616',
};

export const inputStyle = {
  width: '100%',
  borderRadius: '8px',
  fontSize: '16px',
};

export const selectStyle = {
  width: '100%',
  borderRadius: '8px',
  fontSize: '16px',
};

export const textareaStyle = {
  width: '100%',
  height: '100%',
  border: '1px solid #ccc',
  borderRadius: '4px',
  padding: '8px',
  fontSize: '16px',
  fontWeight: 'bold',
};
